// access.ts
// Service function for retrieving environment keys from the proxy server.
// Provides a utility for fetching and decoding environment/configuration keys.

import axios from "@/utils/axios";

interface StringPayload {
  [key: string]: string;
}

/**
 * Retrieves environment/configuration keys from the proxy server.
 * @param keyString - Comma-separated string of keys to request (e.g., 'KEY_ONE,KEY_TWO')
 * @param abort - Abort controller for request cancellation
 * @returns Object mapping key names to their values
 * @example
 *   retrieveKeys('KEY_ONE,KEY_TWO', abortController)
 *   // => { KEY_ONE: 'value', KEY_TWO: 'value' }
 */
export const retrieveKeys = (
  keyString: string,
  abort: AbortController,
): Promise<StringPayload> => {
  return axios
    .get<string>(`/api/access?keys=${keyString}`, {
      signal: abort.signal,
    })
    .then((json): StringPayload => {
      return JSON.parse(atob(json.data)) as StringPayload;
    });
};
